import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { Database } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

import { syncProviderTags } from "./syncProviderTags";

type ProviderInsert = Database['public']['Tables']['providers']['Insert'];
type Command = ProviderInsert & {
  tag_ids?: string[];
};

async function postProvider(command: Command) {
  const { tag_ids, ...providerData } = command;
  const { data, error } = await apiClient
    .from('providers')
    .insert(providerData)
    .select()
    .single();

  if (error) {
    throw error;
  }

  if (tag_ids && tag_ids.length > 0) {
    await syncProviderTags(data.id, tag_ids);
  }

  return data;
}

type Variables = {
  command: Omit<Command, 'space_id'>;
}

export default function usePostProvider() {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: ({ command }: Variables) => postProvider({ ...command, space_id: currentSpace!.id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.getProvidersList(currentSpace!.id) });
    },
  });
}
